/*!
 * @pixi/filter-drop-shadow - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-drop-shadow is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import { KawaseBlurFilter as h } from "@pixi/filter-kawase-blur";
import { settings as p, Filter as d, ObservablePoint as S, utils as s, DEG_TO_RAD as f } from "@pixi/core";
var w = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,
  O = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float alpha;
uniform vec3 color;

uniform vec2 shift;
uniform vec4 inputSize;

void main(void){
    vec4 sample = texture2D(uSampler, vTextureCoord - shift * inputSize.zw);

    // Premultiply alpha
    sample.rgb = color.rgb * sample.a;

    // alpha user alpha
    sample *= alpha;

    gl_FragColor = sample;
}`,
  P = Object.defineProperty,
  c = Object.getOwnPropertySymbols,
  T = Object.prototype.hasOwnProperty,
  z = Object.prototype.propertyIsEnumerable,
  _ = (t, e, i) => e in t ? P(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[e] = i,
  b = (t, e) => {
    for (var i in e || (e = {})) T.call(e, i) && _(t, i, e[i]);
    if (c) for (var i of c(e)) z.call(e, i) && _(t, i, e[i]);
    return t;
  };
const o = class extends d {
  constructor(t) {
    super(), this.angle = 45, this._distance = 5, this._resolution = p.FILTER_RESOLUTION;
    const e = t ? b(b({}, o.defaults), t) : o.defaults,
      {
        kernels: i,
        blur: l,
        quality: r,
        pixelSize: g,
        resolution: n
      } = e;
    this._offset = new S(this._updatePadding, this), this._tintFilter = new d(w, O), this._tintFilter.uniforms.color = new Float32Array(4), this._tintFilter.uniforms.shift = this._offset, this._tintFilter.resolution = n, this._blurFilter = i ? new h(i) : new h(l, r), this.pixelSize = g, this.resolution = n;
    const {
      shadowOnly: m,
      rotation: a,
      distance: u,
      offset: v,
      alpha: y,
      color: x
    } = e;
    this.shadowOnly = m, a !== void 0 && u !== void 0 ? (this.rotation = a, this.distance = u) : this.offset = v, this.alpha = y, this.color = x;
  }
  apply(t, e, i, l) {
    const r = t.getFilterTexture();
    this._tintFilter.apply(t, e, r, 1), this._blurFilter.apply(t, r, i, l), this.shadowOnly !== !0 && t.applyFilter(this, e, i, 0), t.returnFilterTexture(r);
  }
  _updatePadding() {
    const t = Math.max(Math.abs(this._offset.x), Math.abs(this._offset.y));
    this.padding = t + this.blur * 2;
  }
  _updateShift() {
    this._tintFilter.uniforms.shift.set(this.distance * Math.cos(this.angle), this.distance * Math.sin(this.angle));
  }
  set offset(t) {
    this._offset.copyFrom(t), this._updatePadding();
  }
  get offset() {
    return this._offset;
  }
  get resolution() {
    return this._resolution;
  }
  set resolution(t) {
    this._resolution = t, this._tintFilter && (this._tintFilter.resolution = t), this._blurFilter && (this._blurFilter.resolution = t);
  }
  get distance() {
    return this._distance;
  }
  set distance(t) {
    s.deprecation("5.3.0", "DropShadowFilter distance is deprecated, use offset"), this._distance = t, this._updatePadding(), this._updateShift();
  }
  get rotation() {
    return this.angle / f;
  }
  set rotation(t) {
    s.deprecation("5.3.0", "DropShadowFilter rotation is deprecated, use offset"), this.angle = t * f, this._updateShift();
  }
  get alpha() {
    return this._tintFilter.uniforms.alpha;
  }
  set alpha(t) {
    this._tintFilter.uniforms.alpha = t;
  }
  get color() {
    return s.rgb2hex(this._tintFilter.uniforms.color);
  }
  set color(t) {
    s.hex2rgb(t, this._tintFilter.uniforms.color);
  }
  get kernels() {
    return this._blurFilter.kernels;
  }
  set kernels(t) {
    this._blurFilter.kernels = t;
  }
  get blur() {
    return this._blurFilter.blur;
  }
  set blur(t) {
    this._blurFilter.blur = t, this._updatePadding();
  }
  get quality() {
    return this._blurFilter.quality;
  }
  set quality(t) {
    this._blurFilter.quality = t;
  }
  get pixelSize() {
    return this._blurFilter.pixelSize;
  }
  set pixelSize(t) {
    this._blurFilter.pixelSize = t;
  }
};
let F = o;
F.defaults = {
  offset: {
    x: 4,
    y: 4
  },
  color: 0,
  alpha: .5,
  shadowOnly: !1,
  kernels: null,
  blur: 2,
  quality: 3,
  pixelSize: 1,
  resolution: p.FILTER_RESOLUTION
};
export { F as DropShadowFilter };
